// @flow
import * as React from 'react';
import styled from 'styled-components';
import DelimitedInput from 'components/DelimitedInput';
import Input from 'components/Input';
import { colors } from '../theme';

const InputContainer = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  width: 100%;
  position: relative;
  align-items: center;
`;

const DollarSign = styled.span`
  position: absolute;
  z-index: 1;
  top: 12px;
  left: 18px;
  font-size: 18px;
  letter-spacing: 0px;
  color: ${colors.battleshipGrey};
`;

const DollarInput = ({ type, ...props }: { type?: string }) => {
  const InputComponent = type === 'number' ? Input : DelimitedInput;
  return (
    <InputContainer>
      <DollarSign>$</DollarSign>
      <InputComponent
        height="100%"
        width="100%"
        pl="32px"
        type={type}
        {...props}
      />
    </InputContainer>
  );
};

export default DollarInput;
